import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import { SubscriptionType } from '../types/PartnerTypes';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const FLAVOR = import.meta.env.VITE_FLAVOR || process.env.VITE_FLAVOR
export default function SubscriptionCarousel({ subscriptions, partnerId, right = true }: { subscriptions: SubscriptionType[], partnerId: string, right?: boolean }) {
  // subscriptions=[]

  const handleOnClick = (subscription: SubscriptionType) => {
    if(FLAVOR === 'PRODUCTION'){
      window.location.href = `https://plundr.besaksham.com/join-subscription?spid=${partnerId}&subid=${subscription.id}`;
    }else{
      window.location.href = `https://plundrdev.hosaksham.com/join-subscription?spid=${partnerId}&subid=${subscription.id}`;
    }
  }

  return (<section>
    <div className="mx-auto max-w-screen-xl px-0 py-8 sm:px-6 sm:py-8 lg:px-0">
      {/* Mobile Banner - Always shown on top for mobile */}
      <div className="lg:hidden grid place-content-center rounded-lg bg-gray-800 border border-solid p-4 sm:p-8 mb-4">
        <div className="mx-auto max-w-md text-center">
          <header>
            <h2 className="text-xl font-semibold text-gray-100 sm:text-3xl">Subscriptions</h2>
            <p className="mt-2 sm:mt-4 text-gray-300">
              Discover the subscription plans offered by boom essentials to their customers.
            </p>
          </header>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-4 lg:items-stretch">
        {right ? (
          <>
            <div className={`lg:col-span-3 lg:py-4 ${subscriptions.length === 0 ? "lg:col-start-4" : ""}`}>
              {subscriptions.length > 0 ? (
                <div className="flex overflow-x-auto pb-4 diff-scrollbar justify-en">
                  <ul className="flex gap-4">
                    {subscriptions.map((subscription, index) => {
                      return (
                        <li key={index}>
                          <article className="rounded-xl bg-white border border-gray-300 p-3 shadow-lg hover:shadow-xl">
                            <a href="#">
                              <div className="relative flex items-end overflow-hidden rounded-xl">
                                <div className="relative w-full h-40 sm:h-52 aspect-[16/10]"> {/* Set a fixed height for landscape */}
                                  <img
                                    src={subscription.picture}
                                    alt="Subscription Image"
                                    className="object-cover w-full h-full transition-transform duration-300 transform hover:scale-105" // Added zoom effect on hover
                                  />
                                </div>

                              </div>

                              <div className="mt-1 p-2">
                                <div className="overflow-wrap">
                                  <h2 className="text-slate-700 font-semibold">{subscription.Name}</h2>
                                </div>
                                <p className="text-slate-600 mt-1 text-sm whitespace-nowrap max-w-60 overflow-hidden text-ellipsis">{subscription.placeAddress}</p>
                                <p className="text-slate-400 mt-1 text-sm">PaymentCycle - {subscription.PaymentCycle}</p>

                                <div className="mt-2 flex items-end justify-between">
                                  <p>
                                    <span className="text-lg font-bold text-blue-500"> {subscription.Price ? `₹ ${subscription.Price}` : ""}</span>
                                    <span className="text-slate-400 text-sm">/month</span>
                                  </p>

                                </div>
                                <div className='mt-2'>
                                  <button onClick={() => handleOnClick(subscription)}
                                    className="whitespace-nowrap rounded-lg mt-2 flex items-center gap-2 bg-[#1D4ED8] px-4 text-sm py-2 font-semibold text-white transition hover:translate-y-1">
                                    <CommentOutlinedIcon fontSize='small' />
                                    Join Now
                                  </button>
                                </div>

                              </div>
                            </a>
                          </article>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ) : (
                <div className="flex h-full min-h-[300px] items-center justify-center bg-white rounded-xl">
                  <p className="text-xl text-gray-500">More exciting subscriptions coming soon!</p>
                </div>
              )}
            </div>
            
            {/* Desktop Banner - Only visible on desktop */}
            <div className="hidden lg:grid place-content-center rounded-lg bg-gray-800 border border-solid p-4 sm:p-8">
              <div className="mx-auto max-w-md text-center lg:text-right">
                <header>
                  <h2 className="text-xl font-semibold text-gray-100 sm:text-3xl">Subscriptions</h2>
                  <p className="mt-2 sm:mt-4 text-gray-300">
                    Discover the subscription plans offered by boom essentials to their customers.
                  </p>
                </header>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="hidden lg:grid place-content-center rounded-lg bg-pink-800 border border-solid p-4 sm:p-8">
              <div className="mx-auto max-w-md text-center lg:text-left">
                <header>
                  <h2 className="text-xl font-semibold text-gray-100 sm:text-3xl">Subscriptions</h2>
                  <p className="mt-2 sm:mt-4 text-gray-300">
                    Discover the subscription plans offered by boom essentials to their customers.
                  </p>
                </header>
              </div>
            </div>
            <div className="lg:col-span-3 lg:py-4">
              {subscriptions.length > 0 ? (
                <div className="flex overflow-x-auto pb-4 diff-scrollbar">
                  <ul className="flex gap-4">
                    {subscriptions.map((subscription, index) => {
                      return (
                        <li key={index}>
                          <article className="rounded-xl bg-white border border-gray-300 p-3 shadow-lg hover:shadow-xl">
                            <span >
                              <div className="relative flex items-end overflow-hidden rounded-xl">
                                <div className="relative w-full h-40 sm:h-52 aspect-[16/10]"> {/* Set a fixed height for landscape */}
                                  <img
                                    src={subscription.picture}
                                    alt="Subscription Image"
                                    className="object-cover w-full h-full transition-transform duration-300 transform hover:scale-105" // Added zoom effect on hover
                                  />
                                </div>

                              </div>

                              <div className="mt-1 p-2">
                                <div className="overflow-wrap">
                                  <h2 className="text-slate-700 font-semibold">{subscription.Name}</h2>
                                </div>
                                <p className="text-slate-600 mt-1 text-sm whitespace-nowrap max-w-60 overflow-hidden text-ellipsis">{subscription.placeAddress}</p>
                                <p className="text-slate-400 mt-1 text-sm">PaymentCycle - {subscription.PaymentCycle}</p>

                                <div className="mt-2 flex items-end justify-between">
                                  <p>
                                    <span className="text-lg font-bold text-blue-500"> {subscription.Price ? `₹ ${subscription.Price}` : ""}</span>
                                    <span className="text-slate-400 text-sm">/month</span>
                                  </p>

                                </div>
                                <div className='mt-2'>
                                  <button onClick={() => handleOnClick(subscription)}
                                    className="whitespace-nowrap rounded-lg mt-2 flex items-center gap-2 bg-[#1D4ED8] px-4 text-sm py-2 font-semibold text-white transition hover:translate-y-1">
                                    <CommentOutlinedIcon fontSize='small' />
                                    Join Now
                                  </button>
                                </div>

                              </div>
                            </span>
                          </article>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ) : (
                <div className="flex h-full min-h-[300px] items-center justify-center bg-white rounded-xl">
                  <p className="text-xl text-gray-500">More exciting subscriptions coming soon!</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  </section>)
}
